// types.ts for Clip feature
import { BaseFeatureArgs } from '@common/types/queryState';
import { AudioTrackLabel } from '@features/advancedVideoPlayer';
import { DEFAULT_FRAME_RATE, FrameRate, MediaIdentifiers } from './media';

export * from './direct';
export * from './search';
export * from './media';
export * from './workflow';

export type ClipMediaObjectType =
    | 'AUDIO'
    | 'VIDEO'
    | 'IMAGE'
    | 'PACKAGE'
    | 'DOCUMENT'
    | string;

//~ Define your core data model interfaces for this feature
export interface Clip {
    id: string;
    mediaObjectId: string;
    mediaObjectType: ClipMediaObjectType;

    clipName: string;
    title: string;
    episode: string;
    customer: string;
    commercialOffer: string;
    size: string;
    preservationCategory: string;
    checksumCheck: string;
    lto: string;
    container: string;
    codec: string;
    bitRate: string;
    aspectRatio: string;
    audioMapping: string;
    created: string;
    updated: string;
    status: string;
    collectionId?: string;
    frameRate: FrameRate;

    mediaIdentifiers?: MediaIdentifiers;

    // Technical
    fps: string;
    resolution: string;

    // ?
    durationSeconds: number;
    duration: number;
    audioTracks?: AudioTrackLabel[];
    mimeType?: string;
}

//~ Define Backend response types if they differ significantly from your frontend model

//~ Define specific query arguments if not in the API file direclty
export interface GetClipsArgs extends BaseFeatureArgs {
    productionId: string;
}

export interface GetDirectClipArgs extends GetClipsArgs {
    assetId: string;
}

export interface GetMediaUrlArgs {
    productionId: string;
    mediaObjectId: string;
    moiId: string;
}

export interface GetClipMediaArgs {
    productionId: string;
    mediaObjectId: string;
    moiId: string;
}

//~ Define the state shape for your Clip feature's local UI state
export const DEFAULT_CLIP: Clip = {
    id: '',
    mediaObjectId: '',
    mediaObjectType: '',
    clipName: '',
    title: '',
    episode: '',
    customer: '',
    commercialOffer: '',
    size: '',
    preservationCategory: '',
    checksumCheck: '',
    lto: '',
    container: '',
    codec: '',
    bitRate: '',
    aspectRatio: '',
    audioMapping: '',
    created: '',
    updated: '',
    status: '',
    collectionId: '',
    durationSeconds: 0,
    duration: 0,

    frameRate: DEFAULT_FRAME_RATE,
    fps: '',
    resolution: '',
};
